import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=cf6a6122&"
import script from "./ItemView.vue?vue&type=script&lang=ts&"
export * from "./ItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports